import { useEffect, useState } from 'react';
import { getOrganizations } from '../../../api/api';

export const useOrganizations = () => {
  const [organizations, setOrganizations] = useState([]);

  useEffect(() => {
    (async () => {
      const data = await getOrganizations();
      setOrganizations(data);
    })();
  }, []);

  return { organizations };
};
